var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from "react";
var PlaylistTitleError;
(function (PlaylistTitleError) {
    PlaylistTitleError["Empty"] = "empty";
})(PlaylistTitleError || (PlaylistTitleError = {}));
var mapErrorToMessage = function (key) {
    var _a;
    if (!key)
        return "";
    return (_a = {}, _a[PlaylistTitleError.Empty] = "Введите название", _a)[key];
};
export var usePlaylistTitleEdit = function (initial) {
    var _a = __read(React.useState(initial), 2), title = _a[0], setTitle = _a[1];
    var _b = __read(React.useState(null), 2), error = _b[0], setError = _b[1];
    var validate = function () {
        var key = null;
        if (title.length === 0) {
            key = PlaylistTitleError.Empty;
        }
        setError(key);
        return key === null;
    };
    return {
        value: title,
        set: setTitle,
        error: {
            value: Boolean(error),
            set: setError,
            key: error,
            message: mapErrorToMessage(error),
        },
        validate: validate,
    };
};
